import { useAppDispatch } from '@/Application/Hooks/Redux';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import {
  setIsDeleteCompanyModalOpen,
  setIsNeedInvoiceModalOpen
} from '@/modules/perseo-billing/store/slices/billing';
import { Divider, Typography } from '@/modules/perseo-billing/ui/react/src';
import { PdsIcon } from '@/modules/perseo-billing/ui/react/src/components/gamma';

export const AppliedInvoiceFooter = () => {
  const dispatch = useAppDispatch();
  const { editCompanyGtm, deleteCompanyButtonGtm } = useGtmBillingProduct();

  const editCompanyHandler = () => {
    editCompanyGtm();
    dispatch(setIsNeedInvoiceModalOpen(true));
  };

  const deleteCompanyHandler = () => {
    deleteCompanyButtonGtm();
    dispatch(setIsDeleteCompanyModalOpen(true));
  };

  return (
    <div className="co-flex co-flex-col co-w-full co-gap-y-3 co-pt-3">
      <div className="co-w-full">
        <Divider twColor="co-border-pds-primary-200" />
      </div>
      <div className="co-flex co-justify-between">
        <div
          className="co-flex co-items-center co-gap-x-2 co-cursor-pointer"
          onClick={editCompanyHandler}
        >
          <PdsIcon
            className="co-fill-pds-neutral-900"
            icon="PdsEdit"
            width={18}
            height={20}
          />
          <Typography decoration="underline" weight="semibold">
            Editar
          </Typography>
        </div>
        <div
          className="co-flex co-items-center co-gap-x-2 co-cursor-pointer"
          onClick={deleteCompanyHandler}
        >
          <PdsIcon
            className="co-fill-pds-neutral-900"
            icon="PdsDelete"
            width={18}
            height={20}
          />
          <Typography decoration="underline" weight="semibold">
            Eliminar
          </Typography>
        </div>
      </div>
    </div>
  );
};
